export enum MidChipListIconType {
  tag = 'tag',
  drone = 'drone',
}
